// Traduções desta tela — coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'tickets.ticketFormPage.eyebrow': 'Operação',
    'tickets.ticketFormPage.title': 'Novo ticket',
    'tickets.ticketFormPage.modality': 'Modalidade',
    'tickets.ticketFormPage.modalityAria': 'Modalidade da solicitação',
    'tickets.ticketFormPage.modalityOption.harvestTransport': 'Colheita e Transporte',
    'tickets.ticketFormPage.modalityOption.harvest': 'Colheita',
    'tickets.ticketFormPage.modalityOption.transport': 'Transporte',
    'tickets.ticketFormPage.modalityOption.machineMove': 'Movimentação de Máquina',
    'tickets.ticketFormPage.step.contract': 'Contrato',
    'tickets.ticketFormPage.step.loads': 'Cargas',
    'tickets.ticketFormPage.step.machinery': 'Maquinário',
    'tickets.ticketFormPage.hint.oneRowPerLoad': 'uma linha por carga',
    'tickets.ticketFormPage.hint.oneRowPerMachine': 'uma linha por máquina',
    'tickets.ticketFormPage.selectContract': 'Selecione o contrato',
    'tickets.ticketFormPage.searchContract': 'Buscar contrato…',
    'tickets.ticketFormPage.info.producer': 'Produtor',
    'tickets.ticketFormPage.info.city': 'Município',
    'tickets.ticketFormPage.info.originFarm': 'Fazenda de origem',
    'tickets.ticketFormPage.info.farm': 'Fazenda',
    'tickets.ticketFormPage.info.contractDestination': 'Destino do contrato',
    'tickets.ticketFormPage.destinationUnit': 'Unidade de destino',
    'tickets.ticketFormPage.select': 'Selecione',
    'tickets.ticketFormPage.searchDestination': 'Buscar destino…',
    'tickets.ticketFormPage.defaultsHintBefore': 'Padrões: o horário é gerado por “Início + Intervalo”. Edite qualquer célula para ajustar uma carga. Use a ',
    'tickets.ticketFormPage.defaultsHintAfter': ' no cabeçalho de uma coluna para repetir o valor da 1ª carga em todas.',
    'tickets.ticketFormPage.machineHintBefore': 'Máquina e Operador vêm dos conjuntos de maquinário: escolher um preenche o outro. Use a ',
    'tickets.ticketFormPage.machineHintAfter': ' no cabeçalho para repetir o valor da 1ª linha.',
    'tickets.ticketFormPage.field.date': 'Data',
    'tickets.ticketFormPage.field.day': 'Dia',
    'tickets.ticketFormPage.field.time': 'Horário',
    'tickets.ticketFormPage.field.start': 'Início',
    'tickets.ticketFormPage.field.intervalMin': 'Intervalo em min',
    'tickets.ticketFormPage.field.loadsQty': 'Qtd. cargas',
    'tickets.ticketFormPage.field.machinesQty': 'Qtd. máquinas',
    'tickets.ticketFormPage.applyToAll': 'Aplicar a todas',
    'tickets.ticketFormPage.emptyLoads': 'Nenhuma carga. Ajuste a “Qtd. cargas” ou clique em “Adicionar carga”.',
    'tickets.ticketFormPage.addLoad': 'Adicionar carga',
    'tickets.ticketFormPage.emptyMachines': 'Nenhuma máquina. Ajuste a “Qtd. máquinas” ou clique em “Adicionar máquina”.',
    'tickets.ticketFormPage.addMachine': 'Adicionar máquina',
    'tickets.ticketFormPage.col.driver': 'Motorista',
    'tickets.ticketFormPage.col.plate': 'Placa',
    'tickets.ticketFormPage.col.trailer': 'Carreta',
    'tickets.ticketFormPage.col.trip': 'Viagem',
    'tickets.ticketFormPage.col.scheduleSent': 'Mandou Prog.',
    'tickets.ticketFormPage.col.deviation': 'Desvio',
    'tickets.ticketFormPage.col.incident': 'Ocorrência',
    'tickets.ticketFormPage.col.invoice': 'Nota Fiscal',
    'tickets.ticketFormPage.col.cteBatch': 'Nº Lote CT-e',
    'tickets.ticketFormPage.col.notes': 'Observações',
    'tickets.ticketFormPage.col.machine': 'Máquina',
    'tickets.ticketFormPage.col.operator': 'Operador',
    'tickets.ticketFormPage.col.hectares': 'Q. Hectares',
    'tickets.ticketFormPage.col.operatorCode': 'Código OP.',
    'tickets.ticketFormPage.col.miniCharts': 'Mini Gráficos',
    'tickets.ticketFormPage.col.lightFleet': 'Frota Leve',
    'tickets.ticketFormPage.searchDriverOrPlate': 'Buscar motorista ou placa…',
    'tickets.ticketFormPage.searchPlate': 'Buscar placa…',
    'tickets.ticketFormPage.searchTrailer': 'Buscar carreta…',
    'tickets.ticketFormPage.searchMachine': 'Buscar máquina…',
    'tickets.ticketFormPage.searchOperator': 'Buscar operador…',
    'tickets.ticketFormPage.removeLoad': 'Remover carga',
    'tickets.ticketFormPage.removeMachine': 'Remover máquina',
    'tickets.ticketFormPage.applyAllTooltip': 'Aplicar {{label}} da 1ª carga a todas as cargas',
    'tickets.ticketFormPage.toast.columnAppliedLoads': '{{label}}: valor da 1ª carga aplicado às {{count}} cargas.',
    'tickets.ticketFormPage.toast.columnAppliedMachines': '{{label}}: valor da 1ª linha aplicado às {{count}} máquinas.',
    'tickets.ticketFormPage.error.selectContract': 'Selecione o contrato.',
    'tickets.ticketFormPage.error.addMachine': 'Adicione ao menos uma máquina: selecione a máquina ou o operador.',
    'tickets.ticketFormPage.error.selectDestination': 'Selecione o destino.',
    'tickets.ticketFormPage.error.addLoad': 'Adicione ao menos uma carga.',
    'tickets.ticketFormPage.error.loadDateTime': 'Carga {{n}}: informe data e horário.',
    'tickets.ticketFormPage.toast.machinesRegistered': '{{count}} máquinas cadastradas na frente!',
    'tickets.ticketFormPage.toast.loadsCreated': 'Cargas criadas na operação!',
    'tickets.ticketFormPage.creating': 'Criando…',
    'tickets.ticketFormPage.submitMachinery': 'Cadastrar maquinário',
    'tickets.ticketFormPage.submitLoads': 'Criar cargas',
  },
  en: {
    'tickets.ticketFormPage.eyebrow': 'Operations',
    'tickets.ticketFormPage.title': 'New ticket',
    'tickets.ticketFormPage.modality': 'Modality',
    'tickets.ticketFormPage.modalityAria': 'Request modality',
    'tickets.ticketFormPage.modalityOption.harvestTransport': 'Harvest and Transport',
    'tickets.ticketFormPage.modalityOption.harvest': 'Harvest',
    'tickets.ticketFormPage.modalityOption.transport': 'Transport',
    'tickets.ticketFormPage.modalityOption.machineMove': 'Machine Transport',
    'tickets.ticketFormPage.step.contract': 'Contract',
    'tickets.ticketFormPage.step.loads': 'Loads',
    'tickets.ticketFormPage.step.machinery': 'Machinery',
    'tickets.ticketFormPage.hint.oneRowPerLoad': 'one row per load',
    'tickets.ticketFormPage.hint.oneRowPerMachine': 'one row per machine',
    'tickets.ticketFormPage.selectContract': 'Select the contract',
    'tickets.ticketFormPage.searchContract': 'Search contract…',
    'tickets.ticketFormPage.info.producer': 'Producer',
    'tickets.ticketFormPage.info.city': 'City',
    'tickets.ticketFormPage.info.originFarm': 'Origin farm',
    'tickets.ticketFormPage.info.farm': 'Farm',
    'tickets.ticketFormPage.info.contractDestination': 'Contract destination',
    'tickets.ticketFormPage.destinationUnit': 'Destination unit',
    'tickets.ticketFormPage.select': 'Select',
    'tickets.ticketFormPage.searchDestination': 'Search destination…',
    'tickets.ticketFormPage.defaultsHintBefore': 'Defaults: the time is generated from “Start + Interval”. Edit any cell to adjust a load. Use the ',
    'tickets.ticketFormPage.defaultsHintAfter': ' in a column header to repeat the value of the 1st load across all.',
    'tickets.ticketFormPage.machineHintBefore': 'Machine and Operator come from the machinery sets: choosing one fills the other. Use the ',
    'tickets.ticketFormPage.machineHintAfter': ' in the header to repeat the value of the 1st row.',
    'tickets.ticketFormPage.field.date': 'Date',
    'tickets.ticketFormPage.field.day': 'Day',
    'tickets.ticketFormPage.field.time': 'Time',
    'tickets.ticketFormPage.field.start': 'Start',
    'tickets.ticketFormPage.field.intervalMin': 'Interval in min',
    'tickets.ticketFormPage.field.loadsQty': 'Qty. loads',
    'tickets.ticketFormPage.field.machinesQty': 'Qty. machines',
    'tickets.ticketFormPage.applyToAll': 'Apply to all',
    'tickets.ticketFormPage.emptyLoads': 'No loads. Adjust “Qty. loads” or click “Add load”.',
    'tickets.ticketFormPage.addLoad': 'Add load',
    'tickets.ticketFormPage.emptyMachines': 'No machines. Adjust “Qty. machines” or click “Add machine”.',
    'tickets.ticketFormPage.addMachine': 'Add machine',
    'tickets.ticketFormPage.col.driver': 'Driver',
    'tickets.ticketFormPage.col.plate': 'License plate',
    'tickets.ticketFormPage.col.trailer': 'Trailer',
    'tickets.ticketFormPage.col.trip': 'Trip',
    'tickets.ticketFormPage.col.scheduleSent': 'Sched. sent',
    'tickets.ticketFormPage.col.deviation': 'Deviation',
    'tickets.ticketFormPage.col.incident': 'Incident',
    'tickets.ticketFormPage.col.invoice': 'Invoice',
    'tickets.ticketFormPage.col.cteBatch': 'CT-e batch no.',
    'tickets.ticketFormPage.col.notes': 'Notes',
    'tickets.ticketFormPage.col.machine': 'Machine',
    'tickets.ticketFormPage.col.operator': 'Operator',
    'tickets.ticketFormPage.col.hectares': 'Qty. hectares',
    'tickets.ticketFormPage.col.operatorCode': 'Op. code',
    'tickets.ticketFormPage.col.miniCharts': 'Mini charts',
    'tickets.ticketFormPage.col.lightFleet': 'Light fleet',
    'tickets.ticketFormPage.searchDriverOrPlate': 'Search driver or license plate…',
    'tickets.ticketFormPage.searchPlate': 'Search license plate…',
    'tickets.ticketFormPage.searchTrailer': 'Search trailer…',
    'tickets.ticketFormPage.searchMachine': 'Search machine…',
    'tickets.ticketFormPage.searchOperator': 'Search operator…',
    'tickets.ticketFormPage.removeLoad': 'Remove load',
    'tickets.ticketFormPage.removeMachine': 'Remove machine',
    'tickets.ticketFormPage.applyAllTooltip': 'Apply {{label}} from the 1st load to all loads',
    'tickets.ticketFormPage.toast.columnAppliedLoads': '{{label}}: 1st load value applied to {{count}} loads.',
    'tickets.ticketFormPage.toast.columnAppliedMachines': '{{label}}: 1st row value applied to {{count}} machines.',
    'tickets.ticketFormPage.error.selectContract': 'Select the contract.',
    'tickets.ticketFormPage.error.addMachine': 'Add at least one machine: select the machine or operator.',
    'tickets.ticketFormPage.error.selectDestination': 'Select the destination.',
    'tickets.ticketFormPage.error.addLoad': 'Add at least one load.',
    'tickets.ticketFormPage.error.loadDateTime': 'Load {{n}}: enter date and time.',
    'tickets.ticketFormPage.toast.machinesRegistered': '{{count}} machines added to the work front!',
    'tickets.ticketFormPage.toast.loadsCreated': 'Loads created in the operation!',
    'tickets.ticketFormPage.creating': 'Creating…',
    'tickets.ticketFormPage.submitMachinery': 'Register machinery',
    'tickets.ticketFormPage.submitLoads': 'Create loads',
  },
  es: {
    'tickets.ticketFormPage.eyebrow': 'Operación',
    'tickets.ticketFormPage.title': 'Nuevo ticket',
    'tickets.ticketFormPage.modality': 'Modalidad',
    'tickets.ticketFormPage.modalityAria': 'Modalidad de la solicitud',
    'tickets.ticketFormPage.modalityOption.harvestTransport': 'Cosecha y Transporte',
    'tickets.ticketFormPage.modalityOption.harvest': 'Cosecha',
    'tickets.ticketFormPage.modalityOption.transport': 'Transporte',
    'tickets.ticketFormPage.modalityOption.machineMove': 'Transporte de máquina',
    'tickets.ticketFormPage.step.contract': 'Contrato',
    'tickets.ticketFormPage.step.loads': 'Cargas',
    'tickets.ticketFormPage.step.machinery': 'Maquinaria',
    'tickets.ticketFormPage.hint.oneRowPerLoad': 'una fila por carga',
    'tickets.ticketFormPage.hint.oneRowPerMachine': 'una fila por máquina',
    'tickets.ticketFormPage.selectContract': 'Seleccione el contrato',
    'tickets.ticketFormPage.searchContract': 'Buscar contrato…',
    'tickets.ticketFormPage.info.producer': 'Productor',
    'tickets.ticketFormPage.info.city': 'Municipio',
    'tickets.ticketFormPage.info.originFarm': 'Finca de origen',
    'tickets.ticketFormPage.info.farm': 'Finca',
    'tickets.ticketFormPage.info.contractDestination': 'Destino del contrato',
    'tickets.ticketFormPage.destinationUnit': 'Unidad de destino',
    'tickets.ticketFormPage.select': 'Seleccione',
    'tickets.ticketFormPage.searchDestination': 'Buscar destino…',
    'tickets.ticketFormPage.defaultsHintBefore': 'Valores por defecto: la hora se genera con “Inicio + Intervalo”. Edite cualquier celda para ajustar una carga. Use la ',
    'tickets.ticketFormPage.defaultsHintAfter': ' en el encabezado de una columna para repetir el valor de la 1ª carga en todas.',
    'tickets.ticketFormPage.machineHintBefore': 'Máquina y Operador vienen de los conjuntos de maquinaria: elegir uno completa el otro. Use la ',
    'tickets.ticketFormPage.machineHintAfter': ' en el encabezado para repetir el valor de la 1ª fila.',
    'tickets.ticketFormPage.field.date': 'Fecha',
    'tickets.ticketFormPage.field.day': 'Día',
    'tickets.ticketFormPage.field.time': 'Hora',
    'tickets.ticketFormPage.field.start': 'Inicio',
    'tickets.ticketFormPage.field.intervalMin': 'Intervalo en min',
    'tickets.ticketFormPage.field.loadsQty': 'Cant. cargas',
    'tickets.ticketFormPage.field.machinesQty': 'Cant. máquinas',
    'tickets.ticketFormPage.applyToAll': 'Aplicar a todas',
    'tickets.ticketFormPage.emptyLoads': 'Ninguna carga. Ajuste “Cant. cargas” o haga clic en “Añadir carga”.',
    'tickets.ticketFormPage.addLoad': 'Añadir carga',
    'tickets.ticketFormPage.emptyMachines': 'Ninguna máquina. Ajuste “Cant. máquinas” o haga clic en “Añadir máquina”.',
    'tickets.ticketFormPage.addMachine': 'Añadir máquina',
    'tickets.ticketFormPage.col.driver': 'Conductor',
    'tickets.ticketFormPage.col.plate': 'Placa',
    'tickets.ticketFormPage.col.trailer': 'Remolque',
    'tickets.ticketFormPage.col.trip': 'Viaje',
    'tickets.ticketFormPage.col.scheduleSent': 'Prog. enviada',
    'tickets.ticketFormPage.col.deviation': 'Desvío',
    'tickets.ticketFormPage.col.incident': 'Incidencia',
    'tickets.ticketFormPage.col.invoice': 'Factura',
    'tickets.ticketFormPage.col.cteBatch': 'Nº lote CT-e',
    'tickets.ticketFormPage.col.notes': 'Observaciones',
    'tickets.ticketFormPage.col.machine': 'Máquina',
    'tickets.ticketFormPage.col.operator': 'Operador',
    'tickets.ticketFormPage.col.hectares': 'Cant. hectáreas',
    'tickets.ticketFormPage.col.operatorCode': 'Cód. OP.',
    'tickets.ticketFormPage.col.miniCharts': 'Mini gráficos',
    'tickets.ticketFormPage.col.lightFleet': 'Flota ligera',
    'tickets.ticketFormPage.searchDriverOrPlate': 'Buscar conductor o placa…',
    'tickets.ticketFormPage.searchPlate': 'Buscar placa…',
    'tickets.ticketFormPage.searchTrailer': 'Buscar remolque…',
    'tickets.ticketFormPage.searchMachine': 'Buscar máquina…',
    'tickets.ticketFormPage.searchOperator': 'Buscar operador…',
    'tickets.ticketFormPage.removeLoad': 'Quitar carga',
    'tickets.ticketFormPage.removeMachine': 'Quitar máquina',
    'tickets.ticketFormPage.applyAllTooltip': 'Aplicar {{label}} de la 1ª carga a todas las cargas',
    'tickets.ticketFormPage.toast.columnAppliedLoads': '{{label}}: valor de la 1ª carga aplicado a {{count}} cargas.',
    'tickets.ticketFormPage.toast.columnAppliedMachines': '{{label}}: valor de la 1ª fila aplicado a {{count}} máquinas.',
    'tickets.ticketFormPage.error.selectContract': 'Seleccione el contrato.',
    'tickets.ticketFormPage.error.addMachine': 'Añada al menos una máquina: seleccione la máquina o el operador.',
    'tickets.ticketFormPage.error.selectDestination': 'Seleccione el destino.',
    'tickets.ticketFormPage.error.addLoad': 'Añada al menos una carga.',
    'tickets.ticketFormPage.error.loadDateTime': 'Carga {{n}}: indique fecha y hora.',
    'tickets.ticketFormPage.toast.machinesRegistered': '¡{{count}} máquinas registradas en la frente de trabajo!',
    'tickets.ticketFormPage.toast.loadsCreated': '¡Cargas creadas en la operación!',
    'tickets.ticketFormPage.creating': 'Creando…',
    'tickets.ticketFormPage.submitMachinery': 'Registrar maquinaria',
    'tickets.ticketFormPage.submitLoads': 'Crear cargas',
  },
}
